export const VocabDiagnosis = {
    'vitals' : ['Signos vitales', 'Vitals'],

    'temperature' : ['Temperatura (Cº)', 'Temperature (Cº)'],
    'normal_temperature_tooltip': ['Temperatura normal.', 'Normal temperature.'],
    'hypothermia_tooltip': ['', 'Hypothermia'],
    'low_grade_fever_tooltip': ['Febrícula', 'Low grade fever'],
    'fever_tooltip' : ['Fiebre', 'Fever'],

    'heart_rate' : ['Frecuencia cardíaca (ppm)', 'Heart rate'],
    'bradycardia': ['Baricardia', 'Bradycardia'],
    'tachycardia': ['Taquicardia', 'Tachycardia'],

    'blood_pressure_systolic' : ['Presión sistólica (mmHg)', 'Systolic pressure'],
    'blood_pressure_diastolic' : ['Presión diastólica (mmHg)', 'Diastolic pressure'],
    
    'oxygen' : ['Saturación O2 (%)', 'O2 Saturation (%)'],

    'specialty_note' : ['Nota de especialidad', 'Specialty note'],
    'specialty_note_placeholder' : ['Por favor ingrese especialidad', 'Please enter specialty '],
    'dentistry' : ['Odontología', 'Dentistry'],
    'gynecology' : ['Ginecología', 'Gynecology'],


    'interrogation' : ['Interrogatorio.', 'Interrogation.'],
    'interrogation_placeholder' : ['Redacte interrogatorio.', 'Enter interrogation.'],
    'exploration' : ['Exploración.', 'Exploration.'],
    'exploration_placeholder' : ['Redacte exploración.', 'Enter exploration.'],
    
    'laboratory_tests' : ['Laboratorio & Gabinete.', 'Laboratory tests.'],
    'laboratory_tests_placeholder' : ['Estudios prescritos.', 'Prescribed tests.'],

    'diagnosis' : ['Diagnóstico.', 'Diagnosis.'],
    'diagnosis_placeholder': ['Redacte diagnóstico.', 'Enter diagnosis.'],

    'prescription' : ['Receta.', 'prescription.'],
    'prescription_placeholder': ['Redacte prescripción.', 'Enter prescription.'],

    'missing_vitals' : ['Signos vitales faltantes.', 'Missing vitals.'],
    'missing_vitals_message' : ['Por favor introduce signos vitales.', 'Please complete vital signs.'],

    'missing_interrogation' : ['Interrogatorio faltante.', 'Missing interrogation.'],
    'missing_interrogation_message' : ['Por favor completa el interrogatorio.', 'Please include the interrogation.'],

    'missing_exploration' : ['Exploracion faltante.', 'Missing exploration.'],
    'missing_exploration_message' : ['Por favor resume la exploracion.', 'Please complete the exploration.'],

    'missing_diagnosis' : ['Diagnóstico faltantes', 'Missing diagnosis'],
    'missing_diagnosis_message' : ['Por favor completa el diagnostico.', 'Please complete the diagnosis.'],

    'missing_prescription' : ['Receta faltante', 'Missing prescription'],
    'missing_prescription_message' : ['Por favor completa la reecta.', 'Please provide a prescription.'],
  }
    